<h2 mat-dialog-title>
  <!-- <button mat-dialog-close [disabled]="isProcessing">
    <svg width="18px" height="17px">
      <path fill-rule="evenodd" fill="rgb(95, 95, 107)"
        d="M18.000,0.985 L16.957,-0.000 L9.000,7.515 L1.043,-0.000 L-0.000,0.985 L7.956,8.500 L-0.000,16.015 L1.043,17.000 L9.000,9.485 L16.957,17.000 L18.000,16.015 L10.043,8.500 L18.000,0.985 Z" />
    </svg>
  </button>--> Update Access
</h2>
<mat-dialog-content class="mat-typography invite_user">
  <div class="popup_content">
    <app-loader [ShowLoader]="isFetchingFrom" [CStyle]="{'min-height':'150px'}" [text]="'Loading products..'">
    </app-loader>
    <ng-container *ngIf="!isFetchingFrom">
      <h3 class="mb-3">Update users</h3>
      <form [formGroup]="subUsers" autocomplete="false" novalidate>
        <mat-accordion [multi]="true">
          <mat-expansion-panel hideToggle *ngFor="let product of products" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{product.Product}}
              </mat-panel-title>
              <mat-panel-description>
                Allowed users:{{product.TotalUsers}}
                Added users:{{product.selUser}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div [formGroupName]="getControlName(product)" *ngIf="checkControlExists(product)" class="row mt-3">
              <input formControlName="product_id" type="hidden" />
              <div class="col-md-12">
                <mat-form-field class="button_type mb-2" floatLabel="always" appearance="outline">
                  <mat-label for="Users">Choose Users</mat-label>
                  <mat-select multiple formControlName="Users">
                    <mat-option *ngFor="let user of product.Users" [value]="user.User_Id"
                      [disabled]="user.Role_Id === '2'">
                      {{user.Name}} ({{user.Role_Id === '2' ? 'Owner' : (user.Role_Id === '5' ? 'Admin' : 'Member')}})
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error class="mb-3" *ngIf="getControl(product,'Users').hasError('maxlength')">
                  You can only choose maximum {{product.TotalUsers}} user(s).
                </mat-error>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="row row mt-4">
          <div class="col-md-12">
            <div class="form_btns">
              <button mat-flat-button color="primary" [disabled]="isProcessing || !subUsers.valid"
                (click)="saveProducts(subUsers)" type="submit">{{isProcessing ? 'Please Wait...' : 'Save'}}</button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</mat-dialog-content>